<template>
  <div class="expansion-fun-wrapper">
    <title-bar
      :user-info="userParams"
      @switchUser="switchUser"
      @onReCharge="handleChargo"
    ></title-bar>
    <div class="channel-info">
      <common-bg-plate class="channel-chart">
        <detail-section title="通道用户拓扑图">
          <div class="channel-chart-content">
            <div id="chartContainer" class="chart-node"></div>
            <btn-style :btn-list="btnList" class="btn-list-style"></btn-style>
          </div>
        </detail-section>
      </common-bg-plate>
      <common-bg-plate class="channel-params">
        <detail-table
          title="通道信息"
          :show-border="false"
          :table-col="infoTableCol"
          :list="channelDataInfo"
        >
        </detail-table>
      </common-bg-plate>
    </div>
    <common-bg-plate class="transcation-info">
      <detail-section title="交易记录">
        <normal-table
          ref="commonTable"
          :table-col="tableCol"
          :table-data="chanTxList"
          :paging="chanTxPaging"
          @pagination="handleSizeOrPageChange"
        >
        </normal-table>
      </detail-section>
    </common-bg-plate>

    <exit-channel
      ref="exitChannel"
      :user-id="userParams.id"
      @exitChannelSuccess="getChanUser"
    ></exit-channel>
    <initiateTx ref="initiateTx" :user-id="userParams.id" @initiateTxSuccess="onInitiateTxSuccess"></initiateTx>
    <viewMessage ref="viewMessage"></viewMessage>
    <recharge ref="recharge" @getBalance="getBalance"></recharge>
  </div>
</template>

<script>
import themeVarsDefine from '@/mixins/themeVarsDefine'
import adaptation from '@/mixins/adaptation'
import { mapState, mapActions } from 'vuex'
import titleBar from './components/titleBar.vue'
import exitChannel from './components/exitChannel' //退出
import recharge from './components/recharge' //充值
import initiateTx from './components/initiateTx' //发起交易
import viewMessage from './components/viewMessage' //查看消息
import channelNameImg from '@/assets/images/tableIcon/channel-name.png'
import overallBalanceImg from '@/assets/images/tableIcon/overall_balance.png'
import lastOverallBalanceImg from '@/assets/images/tableIcon/last_overall_balance.png'
import myAmountImg from '@/assets/images/tableIcon/my_amount.png'
let echarts = require('echarts')

export default {
  name: 'FunctionDemo',
  components: {
    titleBar,
    exitChannel,
    initiateTx,
    viewMessage,
    recharge
  },
  mixins: [themeVarsDefine, adaptation],
  themeVarsDefine: {
    dark: {
      tooltipBorderColor: '#303C65',
      tooltipBackgroundColor: '#112245',
      tooltipTextColor: '#FFF',
      tooltipAxisLineColor: '#fff',
      tooltipSymbolColor: '#fff'
    },
    default: {
      tooltipBorderColor: '#F9F9F9',
      tooltipBackgroundColor: '#fff',
      tooltipTextColor: '#122836',
      tooltipAxisLineColor: '#122836',
      tooltipSymbolColor: '#1CBCFF'
    }
  },
  adaptationVarsDefine: {
    tooltipBorderWidth: 1,
    tooltipPadding: 16,
    tooltipFontSize: 12,
    tooltipBorderRadius: 2,
    tooltipAxisLineWidth: 1,
    seriesSymbolSize: 46,
    seriesLabelFontSize: 20,
    seriesLineStyleWidth: 2,
    seriesForceEdgeLength: 60
  },
  data() {
    return {
      chart: null,
      btnList: [
        {
          btnContent: '发起交易',
          click: () => {
            return this.launchTransaction()
          },
          icon: 'icon-gen'
        },
        {
          btnContent: '尝试挑战',
          click: () => {
            return this.simulationChallenge()
          },
          icon: 'icon-gen'
        },
        {
          btnContent: '尝试作恶',
          click: () => {
            return this.simulationCrime()
          },
          icon: 'icon-gen'
        },
        {
          btnContent: '退出通道',
          click: () => {
            return this.exit()
          },
          icon: 'icon-gen'
        }
      ],
      infoTableCol: [
        {
          label: '通道名称',
          icon: channelNameImg,
          value: 'chanName'
        },
        {
          label: '当前周期通道总金额',
          icon: overallBalanceImg,
          value: 'currentNum',
          formatter: this.tranMoney
        },
        {
          label: '上个周期通道总金额',
          icon: lastOverallBalanceImg,
          value: 'oldNum',
          formatter: this.tranMoney
        },
        {
          label: '我的质押金额',
          icon: myAmountImg,
          value: 'pledgeNum',
          formatter: this.tranMoney
        }
      ],
      tableCol: [
        {
          prop: 'trade_type',
          label: '交易类型',
          formatter: row => {
            return this.tradeType(row.trade_type)
          }
        },
        {
          prop: 'balance',
          label: '交易金额',
          formatter: row => {
            return `￥${row.balance}`
          }
        },
        {
          prop: 'tx_id',
          label: '交易ID'
        },
        {
          prop: 'user_id',
          label: '用户ID'
        }
      ],
      userParams: {},
      evilText: '',
      challeageText: '',
      channelData: {},
      channelDataInfo: {},
      chanName: '',
      oldNum: 0,
      currentNum: 0,
      userList: [],
      userData: [],
      option: {
        tooltip: {
          // 鼠标是否可以进入悬浮框
          enterable: true,
          // 触发方式 mousemove, click, none, mousemove|click
          triggerOn: `mousemove`,
          // item 图形触发， axis 坐标轴触发， none 不触发
          trigger: `item`,
          // 浮层隐藏的延迟
          hideDelay: 1000,
          // 背景色
          backgroundColor: '#112245',
          borderColor: '#303C65',
          borderWidth: 1,
          padding: 16,
          formatter: this.chartToolTipFormatter,
          textStyle: {
            color: '#fff',
            fontWeight: 400,
            fontSize: 12,
            fontStyle: 'normal',
            lineHeight: 'normal'
          },
          extraCssText: 'border-radius: 2px;'
        },
        animationDurationUpdate: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            type: 'graph',
            layout: 'force',
            force: {
              // 随机节点位置
              initLayout: 'random',
              repulsion: 10000, // 调整节点之间的斥力
              edgeLength: 60 // 调整边的默认长度
              // 其他布局参数...
            },
            symbolSize: 46,
            roam: true,
            label: {
              fontSize: 20,
              show: true
            },
            data: [],
            links: [],
            lineStyle: {
              opacity: 0.9,
              width: 2,
              curveness: 0
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      chanTxList: state => state.expansionDemo.chan_tx_list,
      chanTxPaging: state => state.expansionDemo.chan_tx_paging
    })
  },
  watch: {
    themeVars: function(val) {
      this.chart?.setOption({
        tooltip: {
          borderColor: val.tooltipBorderColor,
          backgroundColor: val.tooltipBackgroundColor,
          textStyle: {
            color: val.tooltipTextColor
          },
          axisPointer: {
            lineStyle: {
              color: val.tooltipAxisLineColor
            }
          }
        }
      })
    },
    adaptationVars: function(val) {
      this.chart?.setOption({
        tooltip: {
          borderWidth: val.tooltipBorderWidth,
          padding: val.tooltipPadding,
          textStyle: {
            fontSize: val.tooltipFontSize
          },
          extraCssText: `border-radius: ${val.tooltipBorderRadius}px;`,
          axisPointer: {
            lineStyle: {
              width: val.tooltipAxisLineWidth
            }
          }
        },
        series: [
          {
            force: {
              edgeLength: val.seriesForceEdgeLength
            },
            symbolSize: val.seriesSymbolSize,
            label: {
              fontSize: val.seriesLabelFontSize
            },
            lineStyle: {
              width: val.seriesLineWidth
            }
          }
        ]
      })
      this.resize()
    },
    '$store.state.expansionDemo.balance'(newValue, oldValue) {
      this.userParams.balance = newValue
    }
  },
  created() {
    this.channelData = JSON.parse(localStorage.getItem('cbaas_expansion_channel_info'))
    this.userParams = JSON.parse(localStorage.getItem('cbaas_expansion_user_info'))
  },
  mounted() {
    this.getBalance()
    this.initChart()
    if (this.userParams) {
      this.getChan()
      this.getList()
    }
    window.addEventListener('resize', this.resize, false)
  },
  methods: {
    ...mapActions(['getChanTxLists']),
    //获取交易列表
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        userId: this.userParams.id,
        chanId: this.channelData.chanId
      }
      this.getChanTxLists(params)
    },
    //处理交易列表分页切换
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    onInitiateTxSuccess() {
      this.getChan()
      this.getList()
    },
    //初始化图
    initChart() {
      let container = document.getElementById('chartContainer')
      let chartbox = echarts.init(container)
      chartbox.setOption(this.option)
      this.chart = chartbox
    },
    resize() {
      this.chart.resize()
    },
    //生成图的默认连接
    generateDefaultLinks() {
      const data = this.userList
      const links = []
      for (let i = 0; i < data.length; i++) {
        for (let j = i + 1; j < data.length; j++) {
          links.push({ source: i, target: j })
        }
      }
      return links
    },
    //获取用户的关联通道
    getChan() {
      let params = {}
      params.userId = this.userParams.id
      params.chanId = this.channelData.chanId
      this.$apis.expansionDemo
        .getChanInfo(params)
        .then(res => {
          if (res) {
            this.channelDataInfo = res.data
            this.getChanUser()
          } else {
            this.userData = []
            this.getNum()
          }
          this.disabled = false
        })
        .catch(err => {
          this.userData = []
          this.getNum()
          this.chart.setOption({
            series: [
              {
                data: [],
                links: this.generateDefaultLinks()
              }
            ]
          })
          this.disabled = false
        })
    },
    //获取通道关联的用户列表
    getChanUser() {
      let params = {}
      params.chanName = this.channelDataInfo.chanName
      this.$apis.expansionDemo
        .getChanUser(params)
        .then(res => {
          if (res) {
            this.userData = res.data
            this.userList = res.data.map((item, index) => {
              let obj = {}
              obj.name = item.userId
              obj.nameText = item.userName
              obj.time = item.createAt
              obj.balance = item.balance
              return obj
            })
            this.chart.setOption({
              series: [
                {
                  data: this.userList,
                  links: this.generateDefaultLinks()
                }
              ]
            })
            this.getNum()
          } else {
            this.userData = []
          }

          this.disabled = false
        })
        .catch(err => {
          this.userData = []
          this.disabled = false
        })
    },
    getNum() {
      this.oldNum = 0
      this.currentNum = 0
      if (this.userData) {
        this.userData.map((item, index) => {
          this.currentNum += Number(item.balance)
          this.oldNum += Number(item.oldBalance)
        })
      }
    },
    //发起交易
    launchTransaction() {
      this.$refs.initiateTx.handleOpen(this.channelDataInfo.chanName)
    },
    //退出通道
    exit() {
      this.$refs.exitChannel.handleOpen(this.channelData.chanName)
    },
    tradeType(type) {
      let arr = ['转出', '转入']
      return arr[type]
    },
    //挑战
    simulationChallenge() {
      let params = {}
      params.chanName = this.channelData.chanName
      params.userId = this.userParams.id
      this.$apis.expansionDemo
        .challeage(params)
        .then(res => {
          if (res) {
            this.$refs.viewMessage.handleOpen(res.data, '尝试挑战')
            this.challeageText = res.data
            this.getChan()
          }
          this.disabled = false
        })
        .catch(err => {
          this.disabled = false
        })
    },
    //作恶
    simulationCrime() {
      let params = {}
      params.chanName = this.channelData.chanName
      params.userId = this.userParams.id
      this.$apis.expansionDemo
        .doEvil(params)
        .then(res => {
          if (res) {
            this.evilText = res.data
            this.$refs.viewMessage.handleOpen(res.data, '尝试作恶')
            this.getChan()
          }
          this.disabled = false
        })
        .catch(err => {
          this.disabled = false
        })
    },
    //切换用户
    switchUser() {
      this.$router.push({
        name: 'expansionLogin'
      })
    },
    //充值
    handleChargo(index) {
      this.activeIndex = index
      this.$refs.recharge.handleOpen(this.userParams)
    },
    getBalance() {
      let params = {
        chainId: this.userParams.chainId,
        certId: this.userParams.certId
      }
      this.$apis.expansionDemo
        .getUserInfo(params)
        .then(res => {
          if (res) {
            this.userParams = res.data
            this.$store.commit('balanceChange', res.data.balance)
            localStorage.setItem('cbaas_expansion_user_info', JSON.stringify(res.data))
          }
        })
        .catch(err => {
          this.disabled = false
        })
    },
    tranMoney(data, value) {
      return `￥${data[value]}`
    },
    chartToolTipFormatter(params) {
      if (params.dataType == 'node') {
        return `<div>
              <div class=title>用户名称：${params.data.nameText}</div>
              <div class=title>余额：￥${params.data.balance}</div>
              <div class=title>时间：${this.$utils.dateFormat(
                'YYYY-mm-dd HH:MM',
                params.data.time
              )}</div>
            </div>`
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.expansion-fun-wrapper {
  @include adaptation(
    (
      --title-bar-margin-bottom: 20px,
      --detail-section-padding: 4px 16px 0,
      --detail-section-content-padding: 4px 0 0,
      --channel-info-height: 342px,
      --channel-info-margin-bottom: 16px,
      --channel-info-common-bg-plate-min-height: 342px,
      --channel-info-channel-chart-content-height: 290px,
      --channel-info-chart-node-margin-bottom: 16px,
      --channel-info-btn-list-style-width: 134px,
      --channel-info-btn-list-style-item-margin-top: 16px,
      --channel-info-channel-params-width: 480px,
      --channel-info-channel-params-margin-left: 16px,
      --channel-info-channel-params-detail-table-el-row-margin: 0 -10px,
      --channel-info-channel-params-detail-table-el-col-padding: 0 10px,
      --transcation-info-common-bg-plate-unavailable-height: 506px,
      --transcation-info-normal-table-unavailable-height: 52px
    )
  );
  --transcation-info-common-bg-plate-min-height: calc(var(--base-main-router-body-avaliable-height) - var(--transcation-info-common-bg-plate-unavailable-height));
  --transcation-info-normal-table-min-height: calc(var(--transcation-info-common-bg-plate-min-height) - var(--transcation-info-normal-table-unavailable-height));
  .expansion-title-bar {
    margin-bottom: var(--title-bar-margin-bottom);
  }

  .cbaas-detail-section /deep/,
  .cbaas-detail-table /deep/ .cbaas-detail-section {
    padding: var(--detail-section-padding);
    .content {
      padding: var(--detail-section-content-padding);
    }
  }

  .channel-info {
    height: var(--channel-info-height);
    margin-bottom: var(--channel-info-margin-bottom);
    display: flex;

    .common-bg-plate {
      min-height: var(--channel-info-common-bg-plate-min-height);

      &.channel-chart {
        flex-grow: 1;

        .channel-chart-content {
          display: flex;
          height: var(--channel-info-channel-chart-content-height);

          .chart-node {
            flex-grow: 1;
            margin-bottom: var(--channel-info-chart-node-margin-bottom);
          }

          .btn-list-style {
            flex-direction: column;
            width: var(--channel-info-btn-list-style-width);

            /deep/ .el-button:not(:first-child) {
              margin-left: 0;
              margin-top: var(--channel-info-btn-list-style-item-margin-top);
            }
          }
        }
      }

      &.channel-params {
        width: var(--channel-info-channel-params-width);
        margin-left: var(--channel-info-channel-params-margin-left);

        .cbaas-detail-table /deep/ {
          .el-row {
            margin: var(--channel-info-channel-params-detail-table-el-row-margin);

            .el-col {
              padding: var(--channel-info-channel-params-detail-table-el-col-padding);
            }
          }
        }
      }
    }
  }

  .transcation-info.common-bg-plate {
    min-height: var(--transcation-info-common-bg-plate-min-height);

    .normal-table-wrap {
      height: 100%;
      min-height: var(--transcation-info-normal-table-min-height);

      /deep/ {
        .el-empty {
          height: 100%;
          min-height: var(--transcation-info-normal-table-min-height);
        }

        .normal-table {
          height: 100%;
          min-height: var(--transcation-info-normal-table-min-height);
        }
      }
    }
  }
}
</style>
